<template>
  <div>
    <v-container class="mt-5 mb-2">
      <v-card class="pa-5">
      <v-row no-gutters>
        <v-col cols="12" lg="1">
          <Validate :v="$v.form.anoletivo">
            <v-autocomplete
              slot-scope="{ props }"
              v-bind="props"
              :items="anoOptions"
              outlined
              label="Ano Letivo*"
              no-data-text="Opções não disponíveis"
              :disabled="turmasLoading"
              :background-color="turmasLoading ? '#f2f2f2' : null"
              v-model="form.anoletivo"
              @change="onChangeAno">
            </v-autocomplete>
          </Validate>
        </v-col>
        <v-col cols="12" lg="6" class="pl-lg-3">
          <Validate :v="$v.form.identificadorcardapioescola">
            <v-select
              slot-scope="{ props }"
              v-bind="props"
              v-model="form.identificadorcardapioescola"
              :items="cardapioOptions"
              item-text="descricaotitulocardapio"
              item-value="identificadorcardapioescola"
              :disabled="turmasLoading"
              :background-color="turmasLoading ? '#f2f2f2' : null"
              label="Título Cardápio*"
              outlined
              ref="cardapio"
              menu-props="offsetY"
              :no-data-text="cardapiosLoading ? 'Carregando dados, aguarde...' :  'Nenhuma opção carregada'"
              :loading="cardapiosLoading"
              loader-height="3"
              @focus="loadCardapioOptions"
              @change="loadTurmas">
            </v-select>
          </Validate>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" lg="7">
          <div>
            <div class="turmas-select-wrapper" :class="form.identificadorcardapioescola && !turmasLoading ? '' : 'disabled'">
              <h2 class="caption mb-2">Turmas*</h2>
              <v-progress-circular
                class="mt-1"
                v-show="turmasLoading"
                size="27"
                width="2"
                indeterminate
                color="primary">
              </v-progress-circular>
              <v-chip-group
                active-class="primary--text"
                v-model="form.turmas"
                column
                multiple>
                <v-chip v-for="turma of turmasOptions" filter outlined :key="turma.cdturma" :value="turma.cdturma">
                  {{ turma.nmturma }}
                </v-chip>
              </v-chip-group>
            </div>
            <span>Selecione as turmas que merendam do cardápio especificado acima</span>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters style="margin-top:15px;">
        <v-col cols="auto">
          <v-btn width="90px" type="submit" @click="salvar" :loading="loading" :disabled="!form.identificadorcardapioescola || turmasLoading" :dark="form.identificadorcardapioescola != '' && !turmasLoading" small color="teal"  class="rounded-sm">Salvar</v-btn>
        </v-col>
      </v-row>
      </v-card>
    </v-container>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0">
      <div class="d-flex justify-space-between align-center">
        <span> {{ submitText }}</span>
        <v-btn class="text-right" variant="text" icon @click="snackbar = false"> <v-icon>close</v-icon> </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, integer, maxLength, array } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const CardapioEscolaRepository = RepositoryFactory.get("cardapioEscola");
const CardapioTurmaRepository = RepositoryFactory.get("cardapioTurma");
const TurmaRepository = RepositoryFactory.get("turma");

const setFormInicial = () => ({
  anoletivo: null,
  identificadorcardapioescola: '',
  turmas: [],
});

export default {
  name: 'CardapioTurma',
  data() {
    return {
      form: setFormInicial(),
      loading: false,
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      cardapioOptions: [],
      cardapiosLoading: false,
      turmasOptions: [],
      turmasLoading: false,
    };
  },
  computed: {
    ...mapGetters(['getAnoAtualServidor', 'getAnoInicioSistema', 'school']),
    anoOptions() {
      if (!this.getAnoAtualServidor) { return []; }
      let retornoOptions = [];
      for (let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
  },
  validations: {
    form: {
      anoletivo: { required, integer },
      identificadorcardapioescola: { required, integer },
      turmas: {
        $each: {
          maxLength: maxLength(4),
        }
      },
    }
  },
  async mounted() {
    this.form.anoletivo = this.getAnoAtualServidor;
    this.$Progress.finish();
  },
  methods: {
    async salvar() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loading = true
      this.msgArrayError = []

      try {
        const { data } = await CardapioTurmaRepository.lancarTurmasPorCardapio(this.form.identificadorcardapioescola, this.form.turmas);
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.$v.$reset()
      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },

    async loadCardapioOptions() {
      if (this.cardapioOptions.length) return;
      this.cardapiosLoading = true
      const { data } = await CardapioEscolaRepository.buscarCardapiosPorEscola(this.form.anoletivo, this.school.cdtipesc, this.school.cdescola);
      this.cardapioOptions = [...data.results]
      this.cardapiosLoading = false
    },

    async loadTurmas() {
      this.turmasOptions = [];
      this.$refs.cardapio.blur();
      this.turmasLoading = true;
      const turmas = TurmaRepository.turmas({aaletivo: this.form.anoletivo, cdtipesc: this.school.cdtipesc, cdescola: this.school.cdescola});
      const turmasL = CardapioTurmaRepository.listarTurmasPorCardapio(this.form.identificadorcardapioescola);
      const [{ data: todasTurmas}, { data: turmasLancadas }] = await Promise.all([turmas, turmasL]);
      this.turmasOptions = [...todasTurmas.results]
      this.form.turmas = [...turmasLancadas.results.map(t => t.cdturma)]
      this.turmasLoading = false;
    },

    async onChangeAno() {
      this.form.identificadorcardapioescola = '';
      this.cardapioOptions = [];
      this.turmasOptions = [];
    },
  },
};
</script>

<style scoped>
.turmas-select-wrapper.disabled {
  background-color: #f2f2f2;
}
.turmas-select-wrapper {
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius:4px;
  position:relative;
  padding: 10px 12px 5px 12px;
  min-height: 56px;
}
.turmas-select-wrapper > h2 {
  position:absolute;
  top: -10px;
  left: 10px;
  background-color:white;
  color:rgba(0, 0, 0, 0.6);
}
.turmas-select-wrapper + span {
  font-size:12px;
  color:rgba(0, 0, 0, 0.6);
  padding-left: 10px;
  display: inline-block;
}
</style>
